import * as z from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const SaveStatementPdfEvent = BaseLoanEvent.extend({
  type: z.literal('saveStatementPdf'),
  url: z.string(),
  paymentDueId: PaymentDueId,
  disableMailTask: z.boolean().optional(),
});
export type SaveStatementPdfEvent = z.infer<typeof SaveStatementPdfEvent>;
